module.exports = __webpack_public_path__ + "img/label-type2.984d69d8.svg";